import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SideBarState = {
  isOpen: boolean;
};

const initialState: SideBarState = {
  isOpen: false,
};

const sideBarSlice = createSlice({
  name: 'sideBarSlice',
  initialState,
  reducers: {
    /**
     * @description toggleSideBar toggles the side bar state
     */
    toggleSideBar: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },

    /**
     * @description openSideBar sets the side bar state to open
     */
    openSideBar: (state) => {
      state.isOpen = true;
    },

    /**
     * @description closeSideBar sets the side bar state to closed
     */
    closeSideBar: (state) => {
      state.isOpen = false;
    },
  },
});

export const { toggleSideBar, openSideBar, closeSideBar } =
  sideBarSlice.actions;
export default sideBarSlice.reducer;
